import { render, staticRenderFns } from "./situation-inner-bv.vue?vue&type=template&id=3cbee74f"
import script from "./situation-inner-bv.vue?vue&type=script&lang=js"
export * from "./situation-inner-bv.vue?vue&type=script&lang=js"
import style0 from "./situation-inner-bv.vue?vue&type=style&index=0&id=3cbee74f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports